<!-- Clio Classic content host (#71, B1). The horizontal tab bar is superseded by
     the config-driven Classic nav in the V2 left sidebar (CLASSIC_NAV → pagelayout).
     This is now a thin content-area host; `.classic-shell` is the hook B2 styles. -->
<div class="classic-shell">
    <router-outlet></router-outlet>
</div>
